// extracted by mini-css-extract-plugin
export default {"button":"styles_button__xVV3C","hidden":"styles_hidden__L81Sh","loading":"styles_loading__4ZA8Q","fadein":"styles_fadein__3Blrz"};